module.exports = __webpack_public_path__ + "static/globart-plakat-rgb-16ab2a4a6f903e94dd701f44e9568ec3.jpg";